// extracted by mini-css-extract-plugin
export var grid = "BlogItemCardGrid-module--grid--LsUGh";
export var gridWrapper = "BlogItemCardGrid-module--gridWrapper--kfPYH";
export var line = "BlogItemCardGrid-module--line--9PoFQ";
export var linesContainer = "BlogItemCardGrid-module--linesContainer--aCyyF";
export var root = "BlogItemCardGrid-module--root--Y6dGz";
export var title = "BlogItemCardGrid-module--title--LZ7vk";